import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import "../../assets/css/pages/feedbacks.css";
import swal from 'sweetalert';
import _ from "lodash";
import {confirmAlert} from "../../Components/Alerts/BasicAlert";
import avatarBlank from "../../assets/media/svg/avatar-blank.svg";

export default function ({productId = null}) {
  const navigate = useNavigate();
  const user = useSelector(state => state.user);
  const token = useSelector(state => state.token);
  const isSuperAdmin = user?.roles?.includes('Super Admin');
  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;


  const [idFilter, setIdFilter] = useState(null);
  const [productFilter, setProductFilter] = useState(null);
  const [firstNameFilter, setFirstNameFilter] = useState(null);
  const [lastNameFilter, setLastNameFilter] = useState(null);
  const [emailFilter, setEmailFilter] = useState(null);
  const [starsFilter, setStarsFilter] = useState(null);

  useEffect(() => {
    triggerDatatable();
  }, []);

  const triggerFilter = (e) => {
    e.preventDefault();
    localStorage.removeItem("DataTables_feedbacks_/feedbacks");
    triggerDatatable();
  }

  const triggerDatatable = () => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#feedbacks').DataTable({
      "ajax": {
        url: process.env.REACT_APP_API_URL + "feedbacks-datatable",
        method: 'GET',
        data: {
          id: idFilter,
          product: productFilter,
          product_id: productId,
          first_name: firstNameFilter,
          last_name: lastNameFilter,
          email: emailFilter,
          stars: starsFilter,
        },
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      "destroy": true,
      "columns": [
        {
          data: 'checkbox',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"></span>
                    </label>`;
          },
        },
        {data: 'id', name: 'id'},
        {
          data: 'product.name', name: 'product.name',
          render: function (data, type, row) {
            return `<div class="ellipsis cursor-pointer fs-7" title="${row?.product.name}">${row?.product.name}</div>`
          }
        },
        {data: 'user.email', name: 'user.email'},
        {
          data: 'avatar',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            let img = row?.user?.image?.url || avatarBlank;

            return `<div class="image" row-id="${row?.user?.id}" style="background: url(${img});" title="Show Customer"></div>
                    <div class="customer-status" title="${row?.user?.is_active ? "Active" : "Blocked"}">
                      <span class="${row?.user?.is_active ? "bg-success" : "bg-danger"}"></span>
                    </div>
                    `;
          },
        },
        {data: 'user.first_name', name: 'user.first_name'},
        {data: 'user.last_name', name: 'user.last_name'},
        {
          data: 'stars',
          render: function (data, type, row) {
            return `${row?.stars}`;
          },
        },
        {
          data: 'created_at',
          searchable: false,
          orderable: true,
          render: function (data, type, row) {
            return new Date(row?.created_at).toLocaleDateString('en-GB');
          },
        },
        {
          data: 'actions',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return (isSuperAdmin ?
              `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                          <button
                          type="button"
                          class="btn btn-primary me-2 mb-3 description"
                          row-id="${row.id}" row-description="${row.description}">
                              <i class="fas fa-bars"></i> Description
                          </button>
                          <button
                          type="button"
                          class="btn btn-danger me-2 mb-1 delete"
                          row-id="${row.id}">
                              <i class="far fa-trash-alt"></i> Delete
                          </button>
                        <div>
                    </div>
                    ` : ``)
          },
        }
      ],
      "order": [[0, "desc"]],
    });

    table.off('click');

    table.on('click', 'thead tr:first-child th:nth-child(6)', function () {
      return false;
    });

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });

    table.on('click', 'button.description', function () {
      const description = $(this).attr("row-description");
      seeReviewDescription(description);
    });

    table.on('click', 'button.delete', function () {
      const id = $(this).attr("row-id");
      confirmAlert('Do you want to delete feedback?', () => {
        axios.delete('feedbacks/' + id).then(res => {
          table.draw(false);
        });
      });
    });

    $("<span class='table-filter-icon br-0-95-rem' title='Filter'><i class='fa fa-filter fs-4 br-1000'></i>Filter</span>")
      .insertAfter("#feedbacks_length label");

    $(".table-filter-icon").click(function () {
      $(".toggle-filter").slideToggle(100)

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

    table.on('draw', function () {
      $(".paginate_button.page-item.previous a").html('<i class="fas fa-chevron-left"></i>');
      $(".paginate_button.page-item.next a").html('<i class="fas fa-chevron-right"></i>');
    });

    table.on('click', '.form-label-checkbox .checkbox', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    $('.toggle-filter').each(function () {
      if ($(this).css('display') == 'block') {
        $(".table-filter-icon").html("<i class='far fa-times-circle fs-4 br-1000'></i>Close");
      }
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });

    $("table.dataTable thead tr:first-child th:nth-child(1)")
      .html(`<label class="form-label-checkbox form-label-checkbox-mark-all  fs-6 fw-bolder text-dark pt-0">
           <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
           <span class="checkmark"><span></span></span>
           </label>`);

  }

  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  const bulkDeleteFeedback = () => {
    swal({
      title: "Are you sure?",
      text: `You want to delete marked feedbacks?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.post('feedbacks/bulk-destroy', {
          productFeedbacks: bulkArray,
        })
          .then(function (res) {
            if (res.status == 200) {
              swal(`Feedbacks has been deleted successfully!`, {
                icon: "success",
              });

              resetMarked();
              $('#feedbacks').DataTable().draw(false);
            }
          })
          .catch(function (error) {
          });
      }
    });
  }

  const seeReviewDescription = (description) => {
    swal({
      title: "Review Description",
      text: description,
    })
  }


  return (
    <>
      <div>
        <div className="toggle-filter display-none">
          <form onSubmit={triggerFilter} className="row">

            <div className="fv-row mb-10 col-xxl-1 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">ID</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="id"
                     onChange={(e) => {
                       setIdFilter(e.target.value)
                     }}
                     value={idFilter}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Product</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="product"
                     onChange={(e) => {
                       setProductFilter(e.target.value)
                     }}
                     value={productFilter}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Email</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="email"
                     onChange={(e) => {
                       setEmailFilter(e.target.value)
                     }}
                     value={emailFilter}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">First Name</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="first_name"
                     onChange={(e) => {
                       setFirstNameFilter(e.target.value)
                     }}
                     value={firstNameFilter}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Last Name</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="last_name"
                     onChange={(e) => {
                       setLastNameFilter(e.target.value)
                     }}
                     value={lastNameFilter}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-1 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Stars</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="stars"
                     onChange={(e) => {
                       setStarsFilter(e.target.value)
                     }}
                     value={starsFilter}
              />
            </div>

            <div className="col-xxl-2 text-right pt-9">
              <button
                className="btn btn-primary"
                title="Filter Table"
                type="submit"
                onClick={triggerFilter}
              >
                <i className="fas fa-sync-alt fs-5 mr-2"></i>
                Filter
              </button>
            </div>
          </form>
        </div>
        <div className="text-right pb-3">
          <div className={`marked-actions d-inline-block ${buttonIsDisabled ? " d-none" : ""}`}>
            <span className="d-inline-block">
              <button
                type="button"
                className="btn btn-danger br-12-5-px w-10-rem"
                onClick={() => bulkDeleteFeedback()}
                disabled={buttonIsDisabled}
              >
                <i className="far fa-trash-alt fs-5 mr-2"></i> Delete
              </button>
            </span>
          </div>
        </div>
        <table id="feedbacks" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th></th>
            <th className="fs-8 pl-1">ID</th>
            <th className="fs-9 px-1">Product Name</th>
            <th className="fs-8 px-1">Email</th>
            <th className="fs-9 px-1">Avatar</th>
            <th className="fs-9 px-1">First name</th>
            <th className="fs-9 px-1">Last name</th>
            <th className="fs-9 px-1">Stars</th>
            <th className="fs-9 px-1">Date</th>
            <th className="fs-9 px-1">Actions</th>
          </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold">
          </tbody>
        </table>
      </div>
    </>
  );
}